import axios from 'axios';
  
const CUSTOM_HEADERS = {
  JSON: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  DATA: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  },
};
  
export const axiosClient = (
  baseUrl,
  typeHeader,
  headers,
  uniteHeaders = false,
) => {
  const getHeaders = () => {
    if (!headers) {
      return CUSTOM_HEADERS[typeHeader];
    }

    return uniteHeaders
      ? {
          ...CUSTOM_HEADERS[typeHeader],
          ...headers,
        }
      : headers;
  };
  
  const configJson = {
    baseURL: baseUrl,
    timeout: 300000,
    headers: getHeaders(),
  };
  
  const instance = axios.create(configJson);
  
  instance.interceptors.request.use(
    async (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );
  
  instance.interceptors.response.use(undefined, (err) => {
    if (err.response) {
      return err.response;
    }

    return false;
  });
  
  return instance;
};
  
export const coreRequest = async (params, method) => {
  let response = {};
  const result = {
    code: 0,
    data: {},
    error: false,
    msgError: '',
  };

  const validations = params.validations;

  try {
    response = await method();

    if (typeof response === 'boolean') {
      throw new Error('Erro ao conectar com a api.');
    }

    if (validations['others']) {
      validations['others'](response);
    }

    if (
      !!validations['codeSuccess'] &&
      response.status !== validations['codeSuccess']
    ) {
      throw new Error(
        response.data[validations['paramMsgError'] || 'error'] || 
        validations['msgError'],
      );
    }

    result.data = response.data;
  } catch (err) {
    result.error = true;
    result.code = response['status'];
    result.msgError = !err['message']
      ? validations['msgError']
      : err.message;
  }

  return { response, result };
};
  
/**
 * Abstrai o método de request para ser utilizado nos services
 */
export const axiosRequest = async (
  method, { uniteHeaders = true, typeHeader = 'JSON', ...params },
) => {
  const api = axiosClient(
    params.host,
    typeHeader,
    params.headers,
    uniteHeaders,
  );

  const methods = {
    GET: () => api.get(params.path, params.config),
    POST: () => api.post(params.path, params.data, params.config),
    PUT: () => api.put(params.path, params.data, params.config),
    PATCH: () => api.patch(params.path, params.data, params.config),
    DELETE: () => api.delete(params.path, params.config),
  };

  return coreRequest(params, methods[method]);
};
  


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/client/index.js